import Api from "../api";
export const endFrameSession = (frameSessionId) => {
    if (frameSessionId) {
        // Try to end frame session
        Api.endFrameSession(frameSessionId)
            .then(() => { })
            .catch(() => { });
    }
};
